<template>

	<div>

		<div class="header-item">
			<router-link :to="`/${mainslug}`" class="btn-back"></router-link>
			<h1>Add object</h1>
		</div>

		<br>
		<br>
		<br>

		<div class="btns-top">
			<a class="btn btn-close fa fa-times transition-fadeinup"></a>
			<a class="btn btn-submit fa fa-save transition-fadeinup transition-delay-01" v-on:click="submitClickHandler"></a>
		</div>

		<div class="row">
			<div class="col-12 transition-fadeinup">
				<h2>General</h2>
				<form action="">

					<ul class="form">
						<li>
							<input type="hidden" name="id" v-model="general.id">
						</li>
						<li>
							<label>Name *</label>
							<input type="text" placeholder="Readable name" v-model="general.name" v-on:input="nameChangedHandler" required>
						</li>
						<li>
							<label>Machine name *</label> <input type="text" placeholder="Machine name" v-model="general.machinename" required>
							<div class="description">this is automatically generated upon object creation. use this for reference
								columns.
							</div>
						</li>
						<li>
							<label>
								Object type *
								<div class="selector">
									<select name="contentType" v-model="general.contenttype" required>
										<option value="content">Content</option>
										<option value="trees">Trees</option>
										<option value="settings">Settings</option>
										<option value="references">References</option>
										<option value="submissions">Submissions</option>
									</select>
								</div>
							</label>
							<div class="description">The type of object that should be created</div>
						</li>
					</ul>

				</form>

			</div>
		</div>
	</div>

</template>

<script>

import validation from '../../modules/forms/validation.js'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'general-object',
	data () {
		return {
			general: {
				id: 0,
				name: '',
				machinename: '',
				contenttype: 'content',
				state: 3
			},
			mainslug: this.getMainSlug()
		}
	},

	created () {

	},

	methods: {
		submitClickHandler (e) {
			e.preventDefault()

			var form = document.querySelector('form')
			var valid = validation.validate(form)
			if (!valid) return

			// add general entity data
			var data = {}
			data.id = this.general.id
			data.name = this.general.machinename
			data.state = this.general.state

			data['settings'] = {
				'contentType': {
					'id': 0,
					'name': 'contentType',
					'value': this.general.contenttype
				}
			}

			data['translations'] = {
				'en': {
					'id': '0',
					'value': this.general.name,
					'market': {
						'id': 1,
						'locale': 'en'
					}
				}
			}

			var json = JSON.stringify(data)

			var url = '/cms/api/entities'
			xhrModule.post(url, json, this.entityPostCompleted.bind(this))
		},

		entityPostCompleted (response) {
			var data = response.data
			// start save animation
			general.saveAnimation()

			// check if this is content, setting or something else
			var pathName = window.location.pathname
			var contentType = pathName.split('/')[1]

			// redirect to edit screen for this entity
			this.$router.push('/' + contentType + '/edit/' + data.id)
		},

		nameChangedHandler (e) {
			this.general.machinename = general.convertToSlug(this.general.name)
		},

		getMainSlug () {
			var pathName = window.location.pathname
			return pathName.split('/')[1]
		}
	}
}

</script>
